export { default } from './WhyDiscountMags';
